// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Search_wrapper__1cY2x","label":"Search_label__9qjQM","control":"Search_control__3pO8E","input":"Search_input__3_v_j","select":"Search_select__2IYRP"};